<template>
    <div>
        <b-modal id="edit-assignment" title="Edit Assignment Information" scrollable hide-footer>
            <form-resource-edit v-if="assignmentResource && !isSaving" :resourceInstance="assignmentResource" :fieldSet="formsets.assignmentFormSet" ref="assignmentEdit" />
            <div v-else>Saving...</div>
            <div class="newUserButtonContainer">
                <b-button @click="closeModal('edit-assignment')">Cancel</b-button>
            </div>
        </b-modal>
        <b-button @click="displayForm">Show Selected Assignment Detail</b-button>
    </div>
</template>

<script>
import Vue from 'vue'
// components&views
import FormResourceEdit from '../../components/form_resource_edit/FormResourceEdit.vue'
import assignmentFormSet from '../../resources/formsets/assignment'
// mixins
import modalMixin from '../../mixins/modal'
import toastMixin from '../../mixins/toast'

export default Vue.extend({
    props: {
        assignmentResource: {
            required: false,
            type: Object,
            default: () => {
                return null
            },
        },
    },
    data() {
        return {
            isSaving: false,
        }
    },
    computed: {
        formsets() {
            return {
                assignmentFormSet,
            }
        },
    },
    mixins: [modalMixin, toastMixin],
    components: {
        FormResourceEdit,
    },
    methods: {
        displayForm() {
            this.showModal('edit-assignment')
        },

        async saveChanges() {
            try {
                this.isSaving = true
                const result = await this.assignmentResource.save()
                if (result.response.status === 200 || result.response.status === 201) {
                    this.createToast('b-toaster-top-center', 'success', true, 'Saved', '')
                    this.closeModal('edit-assignment')
                }
            } catch (error) {
                // console.log(error)
                this.createToast('b-toaster-top-center', 'danger', true, 'Information Saved Error', '')
                throw error
            }
            this.isSaving = false
        },
    },
})
</script>

<style scoped>
.newUserButtonContainer {
    display: flex;
    justify-content: space-between;
}
</style>
